import { h, cloneVNode, render } from "vue"
import BaseNotify from "./index.vue"
const BaseInstance = h(BaseNotify)

let seed = 1

const Notify = (message = "") => {
  // 设置唯一编号
  const id = "message-" + seed++

  const options = typeof message === "object" ? message : { message }
  const cloneInstance = cloneVNode(BaseInstance, options)
  cloneInstance.key = id

  const parent = document.querySelector("body")
  render(cloneInstance, parent)
}

;["success", "error", "warning"].forEach((type) => {
  Notify[type] = (message) => {
    if (typeof message === "object") {
      Notify({ ...message, type })
    } else {
      Notify({ message, type })
    }
  }
})

export default Notify

/* import { h, createApp } from "vue"
import BaseNotify from "./index.vue"
const BaseInstance = h(BaseNotify)

let seed = 1

const Notify = (message = "") => {
  // 设置唯一编号
  const id = "message-" + seed++

  const options = typeof message === "object" ? message : { message }
  const instance = createApp(BaseInstance, options)
  instance.key = id

  const div = document.createElement("div")
  const parent = document.querySelector("body")

  instance.mount(div)

  parent.appendChild(div)
}

;["success", "error", "warning"].forEach((type) => {
  Notify[type] = (message) => {
    if (typeof message === "object") {
      Notify({ ...message, type })
    } else {
      Notify({ message, type })
    }
  }
})

export default Notify */
